// import { Check } from "lucide-react";

import { Check } from "lucide-react";

export default function KotGeneratedModal({
  open,
  onClose,
  order,
  cart = [],
  orderId,
  customerMobile,
  orderType,
  onDirectPrint,
  reciptDetails,
}) {
  const getPrintDateTime = () => {
    const now = new Date();

    const date = now.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${date} ${time}`;
  };

  const parseCustomizations = (item = {}) => {
    const rawCustomization =
      item?.customizations ??
      item?.customization ??
      item?.selectedCustomizations ??
      item?.addons ??
      [];

    if (Array.isArray(rawCustomization)) {
      return rawCustomization;
    }

    if (typeof rawCustomization === "object" && rawCustomization !== null) {
      return [rawCustomization];
    }

    try {
      if (typeof rawCustomization === "string" && rawCustomization.trim()) {
        const parsed = JSON.parse(rawCustomization);

        return Array.isArray(parsed) ? parsed : [parsed];
      }
    } catch (err) {
      console.error("Customization parse error:", err);
    }

    return [];
  };

  const getCustomizationText = (item) => {
    const customizations = parseCustomizations(item);

    return customizations
      .flatMap((customization) => {
        if (typeof customization === "string") {
          return customization;
        }

        if (Array.isArray(customization?.options)) {
          return customization.options.map((option) => {
            if (typeof option === "string") return option;

            return (
              option?.option_name ||
              option?.optionName ||
              option?.name ||
              option?.label ||
              option?.value ||
              ""
            );
          });
        }

        return (
          customization?.option_name ||
          customization?.optionName ||
          customization?.name ||
          customization?.label ||
          customization?.value ||
          ""
        );
      })
      .filter(Boolean)
      .join(", ");
  };

  if (!open) return null;

  const getRawOrderItems = () => {
    const possibleItems = [
      order?.items,
      order?.orderItems,
      order?.order_items,
      order?.itemList,
      order?.itemsList,
      order?.products,
      order?.cart,
      order?.response?.items,
      order?.response?.orderItems,
      order?.response?.order_items,
      Array.isArray(order?.response) ? order.response[0]?.items : null,
      Array.isArray(order?.response) ? order.response[0]?.orderItems : null,
      Array.isArray(order?.response) ? order.response[0]?.order_items : null,
      cart,
    ];

    return (
      possibleItems.find((items) => Array.isArray(items) && items.length > 0) ||
      []
    );
  };

  const normalizeOrderItem = (item = {}) => {
    const qty = Number(
      item?.quantity ??
        item?.qty ??
        item?.item_qty ??
        item?.itemQuantity ??
        item?.count ??
        1,
    );

    const unitPrice = Number(
      item?.item_price ??
        item?.price ??
        item?.unitPrice ??
        item?.unit_price ??
        item?.sellingPrice ??
        item?.selectedPrice?.price ??
        0,
    );

    return {
      ...item,

      item_id:
        item?.item_id ??
        item?.itemId ??
        item?.product_id ??
        item?.productId ??
        item?.id ??
        "",

      item_name:
        item?.item_name ??
        item?.itemName ??
        item?.productName ??
        item?.product_name ??
        item?.actualName ??
        item?.name ??
        "Item",

      productName:
        item?.productName ??
        item?.product_name ??
        item?.item_name ??
        item?.itemName ??
        item?.actualName ??
        item?.name ??
        "Item",

      quantity: qty,
      qty,

      item_price: unitPrice,
      price: unitPrice,

      total_price: Number(
        item?.total_price ??
          item?.totalPrice ??
          item?.item_total ??
          item?.amount ??
          unitPrice * qty,
      ),

      customization:
        item?.customization ??
        item?.customizations ??
        item?.selectedCustomizations ??
        item?.addons ??
        [],

      customizations: parseCustomizations(item),
    };
  };

  const orderItems = getRawOrderItems().map(normalizeOrderItem);

  const subtotal =
    Number(order?.subtotal) ||
    orderItems.reduce((sum, item) => {
      const qty = Number(item.quantity || item.qty || 1);
      const price = Number(item.item_price || item.price || 0);

      return sum + price * qty;
    }, 0);

  const discountAmount = Number(order?.discount_amount || 0);

  const total =
    Number(
      order?.totalOrderPrice || order?.order_amount || order?.pay_amount,
    ) || subtotal - discountAmount;

  const mobile = order?.customer_mobile || customerMobile || "9999999999";

  const type = order?.orderType || orderType || "takeaway";

  const finalOrderId = orderId || order?.orderid || "N/A";

  const rawTableNo =
    order?.table_no ??
    order?.tableNo ??
    order?.table_number ??
    order?.tableNumber ??
    "";

  const tableNo = String(rawTableNo ?? "").trim();
  const hasTableNo = tableNo !== "";

  const restaurantName =
    reciptDetails?.business_name ||
    reciptDetails?.businessName ||
    reciptDetails?.restaurant_name ||
    reciptDetails?.organization_name ||
    reciptDetails?.shop_name ||
    order?.business_name ||
    order?.restaurant_name ||
    order?.organization_name ||
    order?.shop_name ||
    "";

  const handlePrintSlip = () => {
    const rowsHtml = orderItems
      .map((item, index) => {
        const qty = Number(item.quantity || item.qty || 1);

        const unitPrice = Number(item.item_price || item.price || 0);

        const itemName = item.item_name || item.productName || "Item";

        const customizationText = getCustomizationText(item);

        return `
          <div class="kot-row">
            <div>${index + 1}</div>

            <div>
              <div>${itemName}</div>

              ${
                customizationText
                  ? `<div class="custom-text">
                      Custom: ${customizationText}
                    </div>`
                  : ""
              }
            </div>

            <div class="center">${qty}</div>

            <div class="right">
              ${unitPrice.toFixed(2)}
            </div>
          </div>
        `;
      })
      .join("");

    const printWindow = window.open("", "_blank", "width=360,height=700");

    if (!printWindow) return;

    printWindow.document.write(`
      <!DOCTYPE html>

      <html>
        <head>
          <title>KOT Print</title>

          <style>
            @page {
              size: 80mm auto;
              margin: 0;
            }

            html,
            body {
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
              min-height: 100% !important;
              background: #ffffff !important;
              color: #000000 !important;
              font-family: Arial, monospace !important;
              font-size: 12px !important;
              overflow: visible !important;
            }

            body {
              display: flex !important;
              justify-content: center !important;
              align-items: flex-start !important;
            }

            .print-wrapper {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: flex-start;
              padding-top: 8px;
            }

            .kot-slip {
              width: 72mm;
              padding: 2mm 3mm !important;
              box-sizing: border-box;
            }

            .title {
              text-align: center;
              font-weight: 700;
              font-size: 16px;
              line-height: 18px;
              margin: 0 0 6px 0;
            }

            .subtitle {
              text-align: center;
              font-weight: 700;
              font-size: 14px;
              margin: 0 0 8px 0;
            }

            .center {
              text-align: center;
            }

            .right {
              text-align: right;
            }

            .bold {
              font-weight: 700;
            }

            .line {
              border-top: 1px dashed #000;
              margin: 4px 0;
            }

            .kot-row {
              display: grid;
              grid-template-columns: 25px 1fr 35px 50px;
              column-gap: 2px;
              align-items: start;
              padding: 3px 0;
              font-size: 12px;
            }

            .custom-text {
              font-size: 10px;
              margin-top: 2px;
              font-weight: 400;
            }

            .header {
              font-weight: 700;
              padding: 1px 0;
            }

            .print-date {
              text-align: center;
              margin-top: 6px;
              font-size: 12px;
            }

            * {
              box-sizing: border-box;
            }
          </style>
        </head>

        <body>
          <div class="print-wrapper">
            <div class="kot-slip">
             <div class="title">
  ${restaurantName}
</div>

              <div class="subtitle">
                ** KOT **
              </div>

              <div class="center bold">
                Order ID: ${finalOrderId}
              </div>

              <div
                class="center bold"
                style="margin-top: 4px;"
              >
                Order Type: ${type}
              </div>

              ${
                hasTableNo
                  ? `<div class="center bold" style="margin-top: 4px;">
                      Table No: ${tableNo}
                    </div>`
                  : ""
              }

              <div class="line"></div>

              <div class="kot-row header">
                <div>Sr.</div>
                <div>ITEM</div>
                <div class="center">QTY</div>
                <div class="right">PRICE</div>
              </div>

              <div class="line"></div>

              ${rowsHtml}

              <div class="line"></div>

              <div class="print-date">
                Print Date : ${getPrintDateTime()}
              </div>
            </div>
          </div>

          <script>
            window.onload = function () {
              setTimeout(function () {
                window.focus();
                window.print();
              }, 300);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  return (
    <div className="fixed inset-0 z-[99999] bg-black/40 flex items-center justify-center montserrat-font-1 p-3">
      <style>
        {`
          .kot-scroll {
            scrollbar-width: none;
            -ms-overflow-style: none;
          }

          .kot-scroll::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>

      <div className="relative w-[850px] max-h-[94vh] bg-white border-2 border-yellow-400 rounded-xl shadow-2xl p-5 flex gap-4 overflow-hidden">
        {/* LEFT PRINT AREA */}
        <div
          id="kot-print-area"
          className="w-[520px] max-h-[88vh] bg-yellow-50 border border-yellow-400 rounded-md p-4 flex justify-center overflow-hidden"
        >
          <div className="w-full">
            <div className="flex flex-col items-center">
              <div className="w-18 h-18 rounded-full bg-yellow-400 shadow-lg flex items-center justify-center mb-2 p-2">
                <Check size={32} strokeWidth={4} className="text-white" />
              </div>

              <h2 className="text-4xl font-bold text-yellow-500 mb-4">
                KOT Generated
              </h2>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                {restaurantName}
              </h2>
            </div>

            <div className="space-y-2 text-lg mb-4">
              <p>
                <span className="font-bold text-gray-800">
                  Customer Mobile :
                </span>{" "}
                <span className="text-gray-500">{mobile}</span>
              </p>

              <p>
                <span className="font-bold text-gray-800">Order Type :</span>{" "}
                <span className="text-gray-500">{type}</span>
              </p>

              {hasTableNo && (
                <p>
                  <span className="font-bold text-gray-800">Table No :</span>{" "}
                  <span className="text-gray-500">{tableNo}</span>
                </p>
              )}

              {finalOrderId && (
                <p>
                  <span className="font-bold text-gray-800">Order ID :</span>{" "}
                  <span className="text-gray-500">{finalOrderId}</span>
                </p>
              )}
            </div>

            <div className="kot-scroll max-h-[260px] overflow-y-auto overflow-x-hidden mb-4 border border-gray-300 bg-white">
              <table className="w-full bg-white text-sm text-center">
                <thead className="sticky top-0 z-10">
                  <tr className="bg-yellow-100">
                    <th className="border border-gray-300 px-3 py-2">#</th>

                    <th className="border border-gray-300 px-3 py-2">
                      Item Name
                    </th>

                    <th className="border border-gray-300 px-3 py-2">Qty</th>

                    <th className="border border-gray-300 px-3 py-2">
                      Unit Price (₹)
                    </th>

                    <th className="border border-gray-300 px-3 py-2">
                      Total (₹)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {orderItems.map((item, index) => {
                    const qty = Number(item.quantity || item.qty || 1);

                    const unitPrice = Number(
                      item.item_price || item.price || 0,
                    );

                    const rowTotal =
                      Number(item.total_price) ||
                      Number(unitPrice) * Number(qty);

                    const customizationText = getCustomizationText(item);

                    return (
                      <tr key={item.id || item.item_id || index}>
                        <td className="border border-gray-300 px-3 py-2">
                          {index + 1}
                        </td>

                        <td className="border border-gray-300 px-3 py-2 text-left">
                          <div className="font-semibold">
                            {item.item_name || item.productName || "Item"}
                          </div>

                          {customizationText && (
                            <div className="text-xs text-gray-500 mt-1">
                              Custom: {customizationText}
                            </div>
                          )}
                        </td>

                        <td className="border border-gray-300 px-3 py-2">
                          {qty}
                        </td>

                        <td className="border border-gray-300 px-3 py-2">
                          ₹{unitPrice.toFixed(2)}
                        </td>

                        <td className="border border-gray-300 px-3 py-2">
                          ₹{rowTotal.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="border border-yellow-400 rounded-md bg-white p-3 text-lg">
              <div className="flex justify-between mb-3">
                <span className="font-bold text-gray-800">Subtotal:</span>

                <span className="text-gray-500">₹{subtotal.toFixed(2)}</span>
              </div>

              <div className="flex justify-between mb-5">
                <span className="font-bold text-gray-800">
                  Discount Amount:
                </span>

                <span className="text-gray-500">
                  ₹{discountAmount.toFixed(2)}
                </span>
              </div>

              <hr className="mb-4" />

              <div className="flex justify-between text-2xl font-bold text-emerald-600">
                <span>Total :</span>

                <span>₹{Math.round(total)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT ACTIONS */}
        <div className="flex-1 border-l-2 border-dashed border-black pl-4 flex flex-col justify-center gap-3">
          <button
            onClick={onDirectPrint}
            className="h-[78px] border border-gray-500 rounded-md bg-gray-50 shadow-md text-base font-bold hover:bg-gray-100"
          >
            DIRECT PRINT KOT
          </button>

          <button
            onClick={handlePrintSlip}
            className="h-[78px] border border-gray-500 rounded-md bg-gray-50 shadow-md text-base font-bold hover:bg-gray-100"
          >
            PRINT KOT
          </button>

          <button
            onClick={onClose}
            className="h-[78px] border border-gray-500 rounded-md bg-gray-50 shadow-md text-base font-bold hover:bg-gray-100"
          >
            HOME
          </button>
        </div>
      </div>
    </div>
  );
}
